import { PropsWithChildren } from "react";
import Icon from "./Icon";
import styles from "./Tip.module.css";
import Lightbulb from "./icons/lightbulb.svg?react";

const Tip = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.tip}>
      <Icon className={styles.icon} glyph={Lightbulb} />
      <div>
        <strong>Tip</strong>
        <p>{children}</p>
      </div>
    </div>
  );
};

export default Tip;
